import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setSendData} from "../../../Store/Slice/scheduleSlice";
import {useLocation} from "react-router-dom";
import {Tooltip} from "react-tooltip";
import useGetAffirmDueDaysApi from "../../../Global/Api/Schedule/getAffirmDueDaysApi";

export default function ChooseType({type, setType, jobDatetime}) {
  const location = useLocation()
  const dispatch = useDispatch()
  const today =  new Date()
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const totalPrice = useSelector((state) => state.rootReducer.scheduleSlice.total_price);
  const handleType = (status) => {setType(status)};
  const getAffirmDays = useGetAffirmDueDaysApi();

  const initialState = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const tooltipText = `You can choose affirm as a payment method if total price is more than 50$ and ${initialState?.affirm_due_days} or more days left to a job`;

  useEffect(() => {
    if(!type) {
      dispatch(setSendData({ payment_method_id: null }))
      dispatch(setSendData({ payment_brand: null }))
    }
  }, [type])

  useEffect(() => {
    getAffirmDays.get()
  }, [])

  return (
    <div className="payment__cards-choose">
      <div
        style={{width: !(accountData?.country_name === 'United States' || accountData?.country_name === 'Canada') ? '100%' : '50%'}}
        onClick={() => handleType(true)}
        className={`payment__cards-type ${type ? "active" : ""}`}
      >
        <img src="/assets/icons/credit-card.svg" alt="card" />
        <span>Pay by card</span>
      </div>
      {(accountData?.country_name === 'United States' || accountData?.country_name === 'Canada') && ( <>
        {
          Math.floor((new Date(location?.pathname === '/schedule'
            ? initialState?.job_datetime
            : jobDatetime)?.getTime() - today?.getTime()) / (1000 * 60 * 60 * 24)) > +initialState?.affirm_due_days
            && (Number(totalPrice) >= 50 || location?.pathname === '/update-payment')
            ? (<div onClick={() => handleType(false)}
          className={`payment__cards-type ${!type ? "active" : ""}`}>
          <img src="/assets/icons/afrm.svg" alt="afrm"/>
          <span>Affirm</span>
        </div>) : (
          <div data-tooltip-id="affirm-disabled"
               data-tooltip-content={tooltipText} className="payment__cards__disabled">
            <div className="payment__cards__disabled-left">
              <img src="/assets/icons/afrm.svg" alt="afrm"/>
              <span>Affirm</span>
            </div>
            <div className="verify__vehicle-info">
              <img
                src="/assets/icons/lock.svg"
                alt="info"
              />
            </div>
            <Tooltip place="bottom-end" id="affirm-disabled" style={{ zIndex: 999 }} />
          </div>)}
      </>
      )}

    </div>
  );
}
